/** Max session→messageId entries kept in user config. */
export const PLATFORM_CHAT_LAST_SEEN_MESSAGE_IDS_MAX = 100;

export function parsePlatformChatLastSeenMessageIds(
  value: unknown,
): Record<string, string> | undefined {
  if (value == null || typeof value !== 'object' || Array.isArray(value)) {
    return undefined;
  }

  const result: Record<string, string> = {};
  for (const [sessionId, messageId] of Object.entries(
    value as Record<string, unknown>,
  )) {
    if (
      typeof sessionId === 'string' &&
      sessionId.length > 0 &&
      typeof messageId === 'string' &&
      messageId.length > 0
    ) {
      result[sessionId] = messageId;
    }
  }

  return result;
}

export function capPlatformChatLastSeenMessageIds(
  map: Record<string, string>,
  maxEntries: number = PLATFORM_CHAT_LAST_SEEN_MESSAGE_IDS_MAX,
): Record<string, string> {
  const entries = Object.entries(map);
  if (entries.length <= maxEntries) {
    return map;
  }

  return Object.fromEntries(entries.slice(entries.length - maxEntries));
}

export function upsertPlatformChatLastSeenMessageId(
  map: Record<string, string>,
  sessionId: string,
  messageId: string,
): Record<string, string> {
  if (map[sessionId] === messageId) {
    return map;
  }

  const withoutCurrent = { ...map };
  delete withoutCurrent[sessionId];
  return capPlatformChatLastSeenMessageIds({
    ...withoutCurrent,
    [sessionId]: messageId,
  });
}
